import type * as yup from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { eVBInputSchema } from '@/features/EVBService/schema';

export const inputSchema = eVBInputSchema;

export type InputStore = yup.Asserts<typeof inputSchema>;

export const useEVBInputStore = genericStoreFactory(
  () => inputSchema.getDefault(),
  'EVBInputStore',
);
